import app_params from "../../config/params";

const goToRecord = (id) =>
  (window.location.href = `${app_params.basepath}/record/${id}`);

const AcquisitionModal = (props) => {
  return (
    <div className="modal fade" id={props.modalID} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="row p-2">
              <div className="col-12 col-md-5 pe-5">
                <img
                  type="button"
                  src={props.item?.cover}
                  className="figure-img img-fluid rounded border border-1 c-cover-thumb c-cover-thumb-modal"
                  alt={props.item.title}
                  onClick={() => goToRecord(props.item?.id)}
                />
              </div>
              <div className="col-12 col-md-7">
                <div className="c-modal-title">{props.item.title}</div>
                {props.item?.subtitle !== "null" && (
                  <div className="c-modal-subtitle">{props.item.subtitle}</div>
                )}
                <div className="c-divisor">
                  <div className="c-line"></div>
                </div>
                {props.item?.author !== "null" && (
                  <div className="c-modal-author">
                    <span className="c-modal-label">Autores: </span>
                    {props.item.author}
                  </div>
                )}
                {props.item?.editorial !== "null" && (
                  <div className="c-modal-editorial">
                    <span className="c-modal-label">Editorial: </span>
                    {props.item.editorial}
                  </div>
                )}
                {props.item?.place !== "null" && (
                  <div className="c-modal-place">
                    <span className="c-modal-label">Lugar: </span>
                    {props.item.place}
                  </div>
                )}
                {props.item?.year !== "null" && (
                  <div className="c-modal-year">
                    <span className="c-modal-label">Fecha: </span>
                    {props.item.year}
                  </div>
                )}
                {props.item?.series !== "null" && (
                  <div className="c-modal-series">
                    <span className="c-modal-label">Serie: </span>
                    {props.item.series}
                  </div>
                )}
                {props.item?.isbn !== "null" && (
                  <div className="c-modal-isbn">
                    <span className="c-modal-label">ISBN: </span>
                    {props.item.isbn}
                  </div>
                )}
                {props.item?.available === "true" ? (
                  <span className="badge roudend-pill bg-success">
                    <i className="fas fa-check"></i> Disponible
                  </span>
                ):
                (
                  <span className="badge roudend-pill bg-danger">
                    <i className="fas fa-times"></i> No disponible
                  </span>
                )
                }
                {props.item?.file !== "null" && (
                  <div className="c-book-file">
                    <a
                      className="c-button btn btn-outline-primary"
                      href={props.item.file}
                      target="_blank"
                      rel="noreferrer"
                      role="button"
                    >
                      Ver ebook
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcquisitionModal;
